module.exports = __webpack_public_path__ + "static/media/ic-shopping.0be262d0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/ic-shopping.svg
// module id = 666
// module chunks = 14